export default {
      id: "circle__low-battery-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__low-battery",
      toString: function () {
        return this.url;
      }
    }